<template>
  <div class="slide_icon">
    <div class="slide_container">
      <div
        class="icon_item"
        v-for="(item, index) in plat_slide_icons"
        :key="index"
        @click="chosePlatform(item)"
        v-show="
          plat_icons.length == 10 ||
          (plat_icons.length == 9 && item.name != 'QQ超级会员')
        "
      >
        <div class="icon_container" :class="{ icon_chosen: item.chosen }">
          <img :src="item.icon" alt />
        </div>
        <div class="icon_name">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

const { log } = console;
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["show_nine", "plat_icons", "plat_slide_icons"]),
  },
  methods: {
    ...mapMutations(["CHOSEN_PLATFORM"]),
    // 选中平台
    chosePlatform(item) {
      this.CHOSEN_PLATFORM(item);
      this.pageSlide(item.type);
    },
    // 页面滑到指定平台位置
    pageSlide(type) {
      // let current_top =
      //   document.body.scrollTop + document.documentElement.scrollTop;

      let current_top =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let map = {
        0: document.querySelector(".platform_item_0"), // 腾讯视频VIP
        1: document.querySelector(".platform_item_1"), // QQ音乐
        2: document.querySelector(".platform_item_2"), // 优酷VIP
        3: document.querySelector(".platform_item_3"), // 酷狗豪华VIP
        4: document.querySelector(".platform_item_4"), // 懒人听书VIP会员
        5: document.querySelector(".platform_item_5"), // 蜻蜓FM超级会员
        6: document.querySelector(".platform_item_6"), // 百度网盘超级会员
        7: document.querySelector(".platform_item_7"), // 肯德基宅神卡
        8: document.querySelector(".platform_item_8"), // 京东惠购卡
      };
      if (!this.show_nine) {
        map[9] = document.querySelector(".platform_item_9"); // qq超级会员
      }
      const welfare = map[type];
      let speed = 65,
        // ele_top = welfare.offsetTop;
        ele_top = welfare.getBoundingClientRect().top;
      let currentTop = 0;
      let requestId;

      let fixbar_height =
        document.querySelector(".plat_top_fix_bar").clientHeight +
        document.querySelector(".kuaikan_tab").clientHeight;
      // window.scrollTo(0, ele_top);
      // window.scrollBy(0, ele_top-fixbar_height);

      window.scrollBy({
        top: ele_top - fixbar_height,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../css/common.scss";

.slide_icon {
  @include boxsize(710, 154);
  background: #fdf7e7;
}
.slide_container {
  // @include boxsize(664, 154);
  @include boxsize(710, 154);
  @include layout(flex-start, center);
  flex-wrap: nowrap;
  overflow-x: scroll;
  margin: 0 auto;
}

.icon_item {
  @include layout(center, center);
  // margin-right: trans(20);
  a {
    @include layout(center, center);
    text-decoration: none;
  }
  .icon_container {
    @include boxsize(82, 86);
    @include layout(center, center);
    background-color: #fdf7e7;
    border-radius: trans(16);
    img {
      @include boxsize(74, 78);
      display: block;
    }
  }
  .icon_chosen {
    background-color: #ff5e5e;
  }
  .icon_name {
    @include fontstyle(#422323, 22);
    white-space: nowrap;
    line-height: 1.15;
    margin-top: trans(10);
    width:trans(134);
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/act/202010/unit_member/comp/PlatIconSlide.vue